<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    dark
    color="primary darken-1"
    width="292"
  >
    <v-list dense nav>
      <div class="d-flex">
        <div
          class="mr-4"
          style="
            background-color: #ffffff;
            width: 48px;
            height: 48px;
            border-radius: 12px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          "
        >
          <v-img
            style="position: absolute"
            max-height="48"
            src="@/assets/logo-taff-42-2.svg"
          ></v-img>
        </div>
        <div class="mb-4">
          <span style="font-size: 18px; font-weight: 600; line-height: 1">
            masterTime
          </span>
          <div>
            <v-dialog v-model="dialogWebVersion" scrollable max-width="520">
              <template v-slot:activator="{ on, attrs }">
                <button
                  style="font-size: 14px; font-weight: 600; color: #ffffff90"
                  type="button"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ `v.${latestVersion.version}` }} -
                  {{ latestVersion.build_date }}
                </button>
              </template>
              <v-card>
                <v-card-title class="text-h5 d-flex justify-space-between">
                  <span>Web Versions</span>
                  <v-btn icon @click="dialogWebVersion = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text style="height: 60vh">
                  <div v-for="item in versions" :key="item.version">
                    <h3>{{ item.version }} - {{ item.build_date }}</h3>
                    <h3 class="my-2">Fix bug</h3>
                    <ul v-for="fixBug in item.fix_bugs" :key="fixBug.id">
                      <li>{{ fixBug.text }}</li>
                    </ul>
                    <h3 class="mt-4 mb-2">New Feature</h3>
                    <ul
                      v-for="newFeature in item.new_features"
                      :key="newFeature.id"
                    >
                      <li>{{ newFeature.text }}</li>
                    </ul>
                    <v-divider class="my-4"></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>

      <v-divider></v-divider>

      <v-list-item to="/" @click="onClickMenu('home')">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="font-weight: 600">
            หน้าหลัก
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        v-for="menu in mainMenus"
        :key="menu.id"
        v-model="menu.active"
        :prepend-icon="menu.action"
        no-action
        color="white"
        class="sidebar-group"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              v-text="menu.title"
              style="font-weight: 600"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="subItem in menu.items"
          :key="subItem.title"
          :to="subItem.to"
          @click="onClickMenu(menu.id)"
          :disabled="subItem.disabled"
        >
          <v-list-item-content>
            <v-list-item-title
              v-text="subItem.title"
              style="opacity: 80%"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-if="isWebWorkSummaryEnabled && workSummaryMenus.length">
        <v-divider class="my-2"></v-divider>
        <v-subheader style="font-weight: 700; color: #ffffffcc">
          Work Summary
        </v-subheader>

        <v-list-group
          v-for="menu in workSummaryMenus"
          :key="menu.id"
          v-model="menu.active"
          :prepend-icon="menu.action"
          no-action
          color="white"
          class="sidebar-group"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title
                v-text="menu.title"
                style="font-weight: 600"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in menu.items"
            :key="subItem.title"
            :to="subItem.to"
            @click="onClickMenu(menu.id)"
            :disabled="subItem.disabled"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="subItem.title"
                style="opacity: 80%"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import versions from '@/data/data-version.json'

import { mapActions } from 'vuex'
import UIAccessController from '../assets/js/UIAccessController'

const MENU_ACTIVE_KEY_STORAGE = 'menu-active-key'
const FORCED_ENABLED_MENU_RESOURCES = []
const WORK_SUMMARY_MENU_IDS = [
  'daily-data-management',
  'work-summary-reports',
  'leave-settings',
  'attendance-settings',
]

export default {
  data() {
    return {
      versions: versions,
      dialogWebVersion: false,
      menus: [],
    }
  },
  computed: {
    drawer: {
      // getter
      get: function () {
        return this.$store.state.drawer
      },
      // setter
      set: function (value) {
        // do something !
        this.$store.commit('SET_DRAWER', value)
      },
    },
    company() {
      return this.$store.state.company.company || {}
    },
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    latestVersion() {
      return this.versions[0] || { version: '-', build_date: '-' }
    },
    mainMenus() {
      return this.menus.filter(
        (menu) => !WORK_SUMMARY_MENU_IDS.includes(menu.id)
      )
    },
    workSummaryMenus() {
      return this.menus.filter((menu) =>
        WORK_SUMMARY_MENU_IDS.includes(menu.id)
      )
    },
    isWebWorkSummaryEnabled() {
      return this.company.is_web_work_summary !== false
    },
  },
  watch: {
    uiCtrl(value) {
      if (value) {
        this.setMenus()
      }
    },
  },
  async created() {
    if (
      this.$store.state.authentication.authenticationStatus === 'authenticated'
    ) {
      const { admin, employee } = await this.me()
      const companyUuid =
        admin?.company?.company_uuid || employee?.company?.company_uuid

      if (companyUuid) {
        await this.fetchCompany(companyUuid)
      }

      if (admin) {
        const [ui_config, my_policies] = await Promise.all([
          this.fetchUiConfig(admin?.company?.company_uuid),
          this.fetchMyPolicies({
            policy_type: 'admin',
            uuid: admin?.admin_uuid,
          }),
        ])

        const uiCtrl = new UIAccessController(admin, ui_config, my_policies)
        this.$store.commit('SET_UI_CTRL', uiCtrl)
      }

      if (employee) {
        const [ui_config, my_policies] = await Promise.all([
          this.fetchUiConfig(employee?.company?.company_uuid),
          this.fetchMyPolicies({
            policy_type: 'employee',
            uuid: employee?.employee_uuid,
          }),
        ])

        const uiCtrl = new UIAccessController(employee, ui_config, my_policies)
        this.$store.commit('SET_UI_CTRL', uiCtrl)
      }

      this.setMenus()
    }
  },
  methods: {
    ...mapActions({
      me: 'authentication/me',
      fetchCompany: 'company/fetchCompany',
      fetchUiConfig: 'authentication/fetchUiConfig',
      fetchMyPolicies: 'authentication/fetchMyPolicies',
    }),
    onClickMenu(menuId) {
      sessionStorage.setItem(MENU_ACTIVE_KEY_STORAGE, menuId)
    },
    isMenuItemEnabled(item) {
      if (FORCED_ENABLED_MENU_RESOURCES.includes(item.res)) {
        return true
      }

      return this.uiCtrl.isEnable(item.res)
    },
    setMenus() {
      const data = [
        {
          id: 'organization-data',
          action: 'mdi-widgets',
          title: 'ข้อมูลองค์กร',
          items: [
            { title: 'บริษัท', to: '/company', res: 'menu:::company' },
            {
              title: 'สถานที่บริษัทและสาขา',
              to: '/company-location',
              res: 'menu:::company_location',
            },
            {
              title: 'สถานที่บริษัทลูกค้า',
              to: '/offsite-location',
              res: 'menu:::client_site_location',
            },
            { title: 'ปฏิทินวันหยุด', to: '/holiday', res: 'menu:::holiday' },
            {
              title: 'ประเภทพนักงาน',
              to: '/employee-type',
              res: 'menu:::employee_type',
            },
            {
              title: 'โครงสร้างองค์กร',
              to: '/organization',
              res: 'menu:::organization',
            },
            { title: 'ตำแหน่ง', to: '/position', res: 'menu:::position' },
            { title: 'กะทำงาน', to: '/shift', res: 'menu:::shift' },
            {
              title: 'ระดับพนักงาน',
              to: '/employee-level',
              res: 'menu:::employee_level',
            },
            { title: 'คำนำหน้าชื่อ', to: '/prefix', res: 'menu:::prefix' },
            // {
            //   title: 'ผู้อนุมัติลา',
            //   to: '/leave-approver',
            //   res: 'menu:::leave_approver',
            // },
          ],
        },
        {
          id: 'employee-management',
          action: 'mdi-account',
          title: 'จัดการพนักงาน',
          items: [
            { title: 'พนักงาน', to: '/employee', res: 'menu:::employee' },
            // {
            //   title: 'สิทธิ์การลงเวลานอกสถานที่',
            //   to: '/time-attendance-off-site',
            //   res: 'menu:::time_attendance_offsite',
            // },
            // {
            //   title: 'ดาวน์โหลดข้อลูลการลา',
            //   to: '/leave-record/request/download',
            //   res: 'menu:::leave_record',
            // },
          ],
        },
        // {
        //   id: 'card-management',
        //   action: 'mdi-card-account-details',
        //   title: 'จัดการบัตร',
        //   items: [
        //     {
        //       title: 'บัตร',
        //       to: '/card',
        //       res: 'menu:::card_disabled',
        //     },
        //   ],
        // },
        {
          id: 'device-management',
          action: 'mdi-tablet-cellphone',
          title: 'จัดการ Device',
          items: [
            { title: 'พื้นที่', to: '/area', res: 'menu:::area' },
            {
              title: 'รายการ Device',
              to: '/hardware-device',
              res: 'menu:::hardware_device',
            },
            {
              title: 'รายการ Device 3rd Party',
              to: '/hardware-device-3rd-party',
              res: 'menu:::hardware_device_3rd_party',
            },
            {
              title: 'Lock / Unlock',
              to: '/lock-unlock',
              res: 'menu:::lock_unlock',
            },
          ],
        },
        {
          id: 'ta-access-management',
          action: 'mdi-door-closed-lock',
          title: 'จัดการ TA & Access',
          items: [
            {
              title: 'การจัดการ ช่วงเวลา',
              to: '/timezone',
              res: 'menu:::timezone',
            },
            {
              title: 'การจัดการ กลุ่ม Device',
              to: '/hardwares-group',
              res: 'menu:::hardware_group',
            },
            {
              title: 'การจัดการ กลุ่มพนักงาน',
              to: '/employees-group',
              res: 'menu:::employees_group',
            },
            {
              title: 'การจัดการ กลุ่มสิทธิ์',
              to: '/access-authority',
              res: 'menu:::access_authority',
            },
          ],
        },
        {
          id: 'reports',
          action: 'mdi-text-box',
          title: 'รายงาน TA & Access',
          items: [
            {
              title: '[T101] บันทึกเวลา - รายบุคคล',
              to: '/report-t101',
              res: 'menu:::report_t101',
            },
            {
              title: '[T102] บันทึกเวลา - มือถือ',
              to: '/report-t102',
              res: 'menu:::report_t102',
            },
            {
              title: '[T103] บันทึกเวลา - คอลัมน์',
              to: '/report-t103',
              res: 'menu:::report_t103',
            },
            {
              title: '[T104] บันทึกเวลา - อุณหภูมิ',
              to: '/report-t104',
              res: 'menu:::report_t104',
            },
            {
              title: '[T105] บันทึกเวลา - (NFC)',
              to: '/report-t105',
              res: 'menu:::report_t105',
            },
            {
              title: '[T106] บันทึกเวลา - (FILO)',
              to: '/report-t106',
              res: 'menu:::report_t106',
            },
          ],
        },
        {
          id: 'daily-data-management',
          action: 'mdi-table-clock',
          title: 'จัดการข้อมูลประจำวัน',
          items: [
            {
              title: 'ข้อมูลการลา',
              to: '/leave-file',
              res: 'menu:::leave:file',
            },
          ],
        },
        {
          id: 'work-summary-reports',
          action: 'mdi-text-box',
          title: 'รายงาน Work Summary',
          items: [
            {
              title: '[W101] การทำงานรายวัน',
              to: '/report-w101',
              res: 'menu:::report_w101',
            },
          ],
        },
        {
          id: 'attendance-settings',
          action: 'mdi-table-account',
          title: 'ตั้งค่า Work Summary',
          items: [
            {
              title: 'การคิดชั่วโมงงาน',
              to: '/working-hours',
              res: 'menu:::company_config:working_hours',
            },
            {
              title: 'กะทำงาน Work Summary',
              to: '/shift-work-summary',
              res: 'menu:::shift',
            },
          ],
        },
        {
          id: 'leave-settings',
          action: 'mdi-table-cog',
          title: 'ตั้งค่าระบบลา',
          items: [
            // {
            //   title: 'ประเภทการลา',
            //   to: '/leave-type',
            //   res: 'menu:::leave_type',
            // },
            {
              title: 'กำหนดสิทธิ์การลา',
              to: '/leave-entitlement',
              res: 'menu:::company_config:leave_entitlements',
            },
            {
              title: 'สิทธิ์การลาบริษัท',
              to: '/company-leave-right',
              res: 'menu:::leave:leave_rights:company',
            },
            {
              title: 'สิทธิ์การลาพนักงาน',
              to: '/employee-leave-right',
              res: 'menu:::leave:leave_rights:employee',
            },
          ],
        },
        {
          id: 'settings',
          action: 'mdi-cog',
          title: 'ตั้งค่าระบบ',
          items: [
            // {
            //   title: 'ประเภทบัตร',
            //   to: '/card-type',
            //   res: 'menu:::card_type',
            // },
            // { title: 'ประเภทการลงเวลา', to: '/duty', res: 'menu:::duty' },
            {
              title: 'จับคู่ประเภทการลงเวลา',
              to: '/duty-matching',
              res: 'menu:::duty_matching',
            },
            { title: 'ผู้ดูแลระบบ', to: '/admin', res: 'menu:::admin' },
            {
              title: 'การยืนยันตัวตนแบบ 2 ขั้นตอน',
              to: '/two-factor-auth',
              res: 'menu:::company_config:2fa_config',
            },
            {
              title: 'นโยบายรหัสผ่าน',
              to: '/password-policy',
              res: 'menu:::company_config:password_policy',
            },
            // {
            //   title: 'การอนุมัติการลา',
            //   to: '/leave-approval',
            //   res: 'menu:::company_config:leave_approval',
            // },
            {
              title: 'Microsoft Entra ID',
              to: '/microsoft-entra-id',
              res: 'menu:::company_config:microsoft_entra_id',
            },
          ],
        },
        {
          id: 'special-tasks',
          action: 'mdi-tag-multiple',
          title: 'งานพิเศษ',
          items: [
            {
              title: 'ดาวน์โหลด Transaction',
              to: '/download-transaction',
              res: 'menu:::download_transaction',
            },
            {
              title: 'ดาวน์โหลด Transaction (NFC)',
              to: '/download-transaction-nfc',
              res: 'menu:::download_transaction_nfc',
            },
            {
              title: 'บันทึกกิจกรรม (Logs)',
              to: '/activity-log',
              res: 'menu:::activity-log',
            },
            {
              title: 'ส่งประกาศ',
              to: '/announcement',
              res: 'menu:::announcement',
            },
            {
              title: 'รายการประกาศ',
              to: '/announcement-list',
              res: 'menu:::announcement:receiver',
            },
          ],
        },
        {
          id: 'monitoring',
          action: 'mdi-monitor-dashboard',
          title: 'มอนิเตอร์',
          items: [
            {
              title: 'สถานะ Device',
              to: '/hardware-status',
              res: 'menu:::hardware_status',
            },
            {
              title: 'การใช้งาน Device',
              to: '/device-use',
              res: 'menu:::transaction_employee',
            },
          ],
        },
        {
          id: 'webhook',
          action: 'mdi-webhook',
          title: 'Webhook',
          items: [
            {
              title: 'Subscription',
              to: '/webhook-subscription',
              res: 'menu:::webhook:subscription',
            },
            {
              title: 'Developer Email',
              to: '/webhook-developer',
              res: 'menu:::webhook:developer',
            },
            {
              title: 'Resend Transaction',
              to: '/webhook-resend-transaction',
              res: 'menu:::webhook:resend-transaction',
            },
          ],
        },
        {
          id: 'permission-management',
          action: 'mdi-lock',
          title: 'จัดการสิทธิ์การใช้งาน',
          items: [
            { title: 'บทบาท', to: '/user-role', res: 'menu:::user_role' },
            {
              title: 'สิทธิ์ของพนักงาน',
              to: '/employee-policy',
              res: 'menu:::employee_policy',
            },
          ],
        },
      ]

      this.menus = data
        .map((menu) => {
          const items = menu.items.filter(this.isMenuItemEnabled, this)

          if (items.length === 0) {
            return null
          }

          return {
            ...menu,
            items,
          }
        })
        .filter((menu) => menu !== null)

      const menuActiveKey =
        sessionStorage.getItem(MENU_ACTIVE_KEY_STORAGE) || 'home'

      if (!this.menus.length || menuActiveKey === 'home') {
        return
      }

      const activeMenu = this.menus.find((menu) => menu.id === menuActiveKey)

      if (activeMenu) {
        activeMenu.active = true
      }
    },
  },
}
</script>

<style scoped>
.sidebar-group.v-list-group--active
  >>> .v-list-group__header.v-list-item--active {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 5px;
}

/* .sidebar-group >>> .v-list-group__items .v-list-item--active {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
} */
</style>
